var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { cardsSaga } from '@logic/cards';
import { eventsSaga } from '@logic/events';
import { financialsSaga } from '@logic/financials';
import { listingsSaga } from '@logic/listings';
import { manualChiselSaga } from '@logic/manualChisel';
import { marketDataSaga } from '@logic/marketData';
import { newListingSaga } from '@logic/newListing';
import { performerSaga } from '@logic/performer';
import { registrationSaga } from '@logic/registration';
import { reservationsSaga } from '@logic/reservations';
import { searchSaga } from '@logic/search';
import { settingsSaga } from '@logic/settings';
import { transactionConfirmationSaga } from '@logic/transactionConfirmation';
import { transactionsSaga } from '@logic/transactions';
import { uploadImageFilesSaga } from '@logic/uploadImageFiles';
import { userSaga } from '@logic/user';
import { userSettingsSaga } from '@logic/userSettings';
import { venueSaga } from '@logic/venue';
import { workItemsSaga } from '@logic/workItems';
import { csvDownloadSaga } from '@logic/csvDownload';
import { bankAccountsSaga } from './logic/bankAccounts';
import { browserSaga } from '@logic/browser';
import { categoriesSaga } from '@logic/categories';
import { locationsSaga } from '@logic/locations';
import { sitemapSaga } from '@logic/sitemap';
export function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [5 /*yield**/, __values(cardsSaga())];
            case 1:
                _a.sent();
                return [5 /*yield**/, __values(csvDownloadSaga())];
            case 2:
                _a.sent();
                return [5 /*yield**/, __values(categoriesSaga())];
            case 3:
                _a.sent();
                return [5 /*yield**/, __values(locationsSaga())];
            case 4:
                _a.sent();
                return [5 /*yield**/, __values(bankAccountsSaga())];
            case 5:
                _a.sent();
                return [5 /*yield**/, __values(eventsSaga())];
            case 6:
                _a.sent();
                return [5 /*yield**/, __values(financialsSaga())];
            case 7:
                _a.sent();
                return [5 /*yield**/, __values(listingsSaga())];
            case 8:
                _a.sent();
                return [5 /*yield**/, __values(manualChiselSaga())];
            case 9:
                _a.sent();
                return [5 /*yield**/, __values(newListingSaga())];
            case 10:
                _a.sent();
                return [5 /*yield**/, __values(registrationSaga())];
            case 11:
                _a.sent();
                return [5 /*yield**/, __values(settingsSaga())];
            case 12:
                _a.sent();
                return [5 /*yield**/, __values(marketDataSaga())];
            case 13:
                _a.sent();
                return [5 /*yield**/, __values(searchSaga())];
            case 14:
                _a.sent();
                return [5 /*yield**/, __values(uploadImageFilesSaga())];
            case 15:
                _a.sent();
                return [5 /*yield**/, __values(userSaga())];
            case 16:
                _a.sent();
                return [5 /*yield**/, __values(userSettingsSaga())];
            case 17:
                _a.sent();
                return [5 /*yield**/, __values(performerSaga())];
            case 18:
                _a.sent();
                return [5 /*yield**/, __values(browserSaga())];
            case 19:
                _a.sent();
                return [5 /*yield**/, __values(reservationsSaga())];
            case 20:
                _a.sent();
                return [5 /*yield**/, __values(sitemapSaga())];
            case 21:
                _a.sent();
                return [5 /*yield**/, __values(transactionConfirmationSaga())];
            case 22:
                _a.sent();
                return [5 /*yield**/, __values(transactionsSaga())];
            case 23:
                _a.sent();
                return [5 /*yield**/, __values(venueSaga())];
            case 24:
                _a.sent();
                return [5 /*yield**/, __values(workItemsSaga())];
            case 25:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
